export const genderData = ["مرد", "زن"];
export const FEILD_TYPE = [
  { id: 1, title: "textField" } /* output => string */,
  { id: 2, title: "textArea" } /* output => string */,
  //{ id: 3, title: "tag" } /* output => list of string */,
  { id: 4, title: "select" } /* output => id */,
  { id: 5, title: "autoComplete" } /* output => id */,
 // { id: 6, title: "multipleSelect" } /* output => list of ids */,
  { id: 7, title: "checkBox" } /* output => list of ids */,
  { id: 8, title: "radio" } /* output => id */,
 // { id: 9, title: "ballon" } /* output => id */,
  { id: 10, title: "color" } /* output => id */,
  { id: 11, title: "calendar" } /* output => date */,
  { id: 12, title: "dateSelector" } /* output => date */,
  { id: 13, title: "switch" } /* output => boolean */,
//  { id: 14, title: "fileUploader" } /* output => file */,
  { id: 15, title: "numberInput" } /* output => number */,
];
export const FILTER_TYPE = [
  { id: 1, title: "color" } /* output => list of string */,
  { id: 2, title: "checkBox" } /* output => list of string */,
  { id: 3, title: "range" } /* output => list of string */,
  { id: 4, title: "switch" } /* output => booean */,
];
export const AD_Type = [
  { id: 1, title: "طرح طلایی" },
  { id: 2, title: "طرح نقره" },
  { id: 3, title: "طرح برنز" },
];
export const PRICE_TYPE = [
  { id: 1, title: "طرح طلایی" },
  { id: 2, title: "طرح نقره" },
  { id: 3, title: "طرح برنز" },
];
